import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-03709e80"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "course-img"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "course-name text-overflow",
  id: "courseName"
};
const _hoisted_6 = {
  class: "bottom"
};
const _hoisted_7 = {
  class: "course-teacher text-overflow"
};
const _hoisted_8 = {
  class: "course-data"
};
const _hoisted_9 = {
  class: "data-item"
};
const _hoisted_10 = {
  class: "num"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "span"
}, "累计选课", -1));

const _hoisted_12 = {
  class: "data-item"
};
const _hoisted_13 = {
  class: "num"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "span"
}, "学分", -1));

const _hoisted_15 = {
  class: "data-item"
};
const _hoisted_16 = {
  class: "num"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "span"
}, "学时", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goDetail && $options.goDetail(...args)),
    class: "course-card"
  }, [$props.showResultTag && $props.courseData.results_id ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "tag-btn",
    style: _normalizeStyle({
      background: $props.resultMap[$props.courseData.results_id]
    })
  }, _toDisplayString($props.courseData.results_name), 5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $props.courseData.course_cover_url || require('@/assets/images/common/course_cover.png')
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, _toDisplayString($props.courseData.course_name), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createTextVNode(_toDisplayString($props.courseData.lecturer) + " ", 1), _withDirectives(_createElementVNode("span", null, "|", 512), [[_vShow, $props.courseData.lecturer && $props.courseData.organ_name]]), _createTextVNode(" " + _toDisplayString($props.courseData.organ_name), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString($props.courseData.students_num || 0), 1), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString($props.courseData.credit || 0), 1), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString($props.courseData.hours || 0), 1), _hoisted_17])])])])]);
}